import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MessageService, TreeNode} from 'primeng/api';
import {FilterSaveListService} from './filter-save-list/filter-save-list.service';
import {DateFilterType, Field, Filter, GroupField, InfoView, isEmptinessFilterType, ListFilterType, NumberFilterType, Query, StringFilterType, ValueType} from './filter.type';
import {ClassicSave} from './filter-save-list/filter-save-list.component';

type CurrentValue = string | number | boolean | Date | [Date, Date];

@Component({
    selector: 'dmp-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class FilterComponent implements OnInit, OnChanges {
    @Input() fields: Field[] | GroupField[] = [];
    @Input() grouped = false;
    @Input() tenant: string;
    @Output() onFilterChanged = new EventEmitter<Filter[]>();
    @Output() onFilterTreeChanged = new EventEmitter<TreeNode[]>();
    @Output() onLoadPreset = new EventEmitter<ClassicSave>();

    string_type = Object.values(StringFilterType).map((value) => ({code: value, value}));
    number_type = Object.values(NumberFilterType).map((value) => ({code: value, value}));
    date_type = Object.values(DateFilterType).map((value) => ({code: value, value}));
    list_type = Object.values(ListFilterType).map((value) => ({code: value, value}));

    currentField: Field = null;
    currentType: { code: string, value: string } = null;
    currentValue: CurrentValue | CurrentValue[] = null;

    filters: Filter[] = [];

    @Input() id = '';
    @Input() presets = false;

    @Input() currentQuery: Query;

    @Input() currentView: InfoView;

    readonly defaultValues = {
        string: StringFilterType.CONTAINS,
        number: NumberFilterType.EQUALS,
        date: DateFilterType.RANGE,
        list: ListFilterType.EXACTLY
    };

    readonly isEmptinessFilterType = isEmptinessFilterType;
    readonly dateRange = DateFilterType.RANGE;
    readonly dateExact = DateFilterType.EXACTLY;

    filtersTree: TreeNode[];

    constructor(private messageService: MessageService, private filterSaveService: FilterSaveListService) {
    }

    ngOnInit(): void {
        this.filterSaveService.actual$.subscribe((el) => el && this.handleFilterChanged(el.json));
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fields) {
            if (this.grouped && this.fields) {
                this.fields.forEach(group => {
                    group = group as GroupField;
                    group.items.forEach(i => {
                        i.group = group.label;
                    });
                });
            }
        }
    }

    searchFields(fields: Field[] | GroupField[] = [], grouped: boolean, action: (field: Field) => boolean) {
        if (grouped) {
            for (const grouped of fields) {
                const el = this.searchFields((grouped as GroupField).items, false, action);
                if (el) {
                    return el;
                }
            }
            return null;
        } else {
            return (fields as Field[]).find(action);
        }
    }

    add() {
        if (!this.currentField) {
            this.messageService.add({severity: 'error', summary: 'Champ incorrect ou vide', detail: 'Le champ doit être précisé'});
            return;
        }
        if (this.currentField.variableType === 'boolean' && this.currentValue === null) {
            this.currentValue = false;
        }
        if (!this.currentType && this.currentField.variableType !== 'boolean' && this.currentField.variableType !== 'list') {
            this.messageService.add({severity: 'error', summary: 'Champ incorrect ou vide', detail: 'Le type doit être précisé'});
            return;
        }
        if (!isEmptinessFilterType(this.currentType?.code) && (this.currentValue === null || this.currentValue === undefined)) {
            this.messageService.add({severity: 'error', summary: 'Champ incorrect ou vide', detail: 'La valeur doit être précisée'});
            return;
        }
        this.filters = [...this.filters, {
            field: this.currentField,
            filterType: this.currentType,
            value: this.currentValue,
            edit: false,
            schema: this.searchFields(this.fields, this.grouped, ((field) => field.name === this.currentField.name))?.schema
        }];
        this.currentField = null;
        this.currentType = null;
        this.currentValue = null;
        this.handleFilterChanged();
    }



    handleFilterTreeChanged($event: TreeNode[]) {
    this.onFilterTreeChanged.emit($event);
    }


    handleFilterChanged(filters: Filter[] = undefined) {
        if (filters) {
            this.filters = filters;
        }
        this.onFilterChanged.emit(this.filters.map((filter) => {
            if (filter.value === null || filter.value === undefined) {
                return filter;
            } else if ((filter.value as { code: string, value: string }).code) {
                return {...filter, value: (filter.value as { code: string, value: string }).code};
            } else if (Array.isArray(filter.value) && filter.value.length > 0 &&
                (filter.value[0] as { code: string, value: string }).code) {
                return {...filter, value: filter.value.map(el => (el as { code: string, value: string }).code)};
            }
            return filter;
        }));
    }

    async clearCurrent() {
        // console.log('HELLO>', this.currentField.variableType)
        if (this.currentField) {
            this.currentType = {
                code: this.defaultValues[this.currentField.variableType],
                value: this.defaultValues[this.currentField.variableType]
            };
        } else {
            this.currentType = null;
        }
        this.currentValue = null;
    }

    clearFilters() {
        this.filters.splice(0, this.filters.length);
        this.handleFilterChanged();
    }

    resetFilters() {
        this.filters = [];
        this.handleFilterChanged();
    }
}
